import { css } from 'styled-components';
import {
  BreakpointQueryName,
  ThemedFunctor,
} from '@doveit/lego';

export const base: ThemedFunctor = () => css`
  display: flex;
`;

export const picture: ThemedFunctor = ({ theme }) => css`
  flex-shrink: 0;
  width: 4.5rem;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: 9.5rem;
  }
`;

export const pictureWrapper: ThemedFunctor = ({ theme }) => css`
  flex-shrink: 0;
  width: 3.25rem;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: 5.5rem;
  }
`;

export const info: ThemedFunctor = () => css`
  flex-grow: 1;
`;
